/**
 * Aparición al hacer scroll de las secciones marcadas con [data-revelar].
 *
 * Regla de oro: el contenido NUNCA depende de que esto funcione. El CSS solo oculta las
 * secciones si este script ha marcado <html> con .kotashi-anim, así que sin JS se ve todo.
 * Y si el IntersectionObserver existe pero no llega a disparar (pasa en algunos webviews y
 * paneles de previsualización), el guardia de abajo lo detecta y lo enseña todo igualmente.
 * Preferimos quedarnos sin animación antes que dejar la página en blanco.
 */
(() => {
  const elementos = document.querySelectorAll('[data-revelar]');
  if (!elementos.length) return;

  const mostrarTodo = () => {
    for (const el of elementos) el.classList.add('kotashi-visible');
  };

  const reduceMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMovimiento || !('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('kotashi-anim');

  let haDisparado = false;
  const observador = new IntersectionObserver(
    (entradas) => {
      haDisparado = true;
      for (const entrada of entradas) {
        if (!entrada.isIntersecting) continue;
        entrada.target.classList.add('kotashi-visible');
        observador.unobserve(entrada.target);
      }
    },
    { threshold: 0.15 }
  );

  for (const el of elementos) observador.observe(el);

  // Un observador sano invoca su callback nada más observar, aunque nada intersecte.
  // Si a los 400 ms no ha dicho ni mu, no es de fiar: fuera animación y a ver el contenido.
  setTimeout(() => {
    if (haDisparado) return;
    observador.disconnect();
    document.documentElement.classList.remove('kotashi-anim');
    mostrarTodo();
  }, 400);
})();
